




































import { Component, Prop, Vue } from 'vue-property-decorator';

import CategoryItem from '@/components/molecules/CategoryItemV2/CategoryItem.vue';
import isMobile from '@/utils/mobile-check';

interface ICategory {
  value: string;
  label: string;
}

export function isOtherCategory(label: string) {
  const regex = /\bother(s)?\b/i;

  return regex.test(label);
}

@Component({
  components: {
    CategoryItem
  }
})
export default class Categories extends Vue {
  @Prop() readonly categories!: ICategory[];
  @Prop({ default: '' }) readonly value?: string;
  @Prop({ default: '' }) readonly otherValue?: string;
  @Prop({ default: [] }) readonly errors!: string[];
  @Prop({ default: [] }) readonly errorEmpty!: string[];

  isMobileDevice = isMobile();
  isOtherCategory = isOtherCategory;

  focusedInput = false;

  handleOnClick(category: ICategory) {
    if (
      this.value === category.value &&
      !this.isOtherCategory(category.label)
    ) {
      this.handleOnClose();

      return;
    }

    this.$emit('changeCategory', category);
  }

  handleOnClose() {
    this.$emit('closeCategory');
  }
}
